import { type FC } from "react";
import { ProductTabularViewActionCell } from "~/Search/components/ProductResults/views/TabularView/ProductTabularViewActionCell/ProductTabularViewActionCell";
import { LinkButton } from "../../../common/components/Link";
import { type TabularViewData } from "../../../Search/models";
import { type Row } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { openModal } from "~/AddToCart/ModalSevice";
import { VariantProductsTableModal } from "~/HousingSelectionAssistant/components/VariantProductsTableModal/VariantProductsTableModal";
import {
  PurchasePlaceProvider,
  PurchaseTypeProvider,
} from "~/feature/Analytics/ga/recommendations/RecommendationContexts";

interface Props {
  row: Row<TabularViewData>;
}

export const HousingProductTabularViewActionCell: FC<Props> = ({ row }: Props) => {
  const { product, variantProducts } = row.original;
  const { t } = useTranslation();
  const isExpandActionCell = variantProducts.length > 0;

  if (isExpandActionCell) {
    return (
      <div className={"d-flex flex-justify-center"}>
        <LinkButton
          data-test-id={"tabular-view-action-button-expand-details"}
          onClick={() => {
            openModal("housing-details", (close) => (
              <PurchasePlaceProvider value={"HSA"}>
                <PurchaseTypeProvider value={"hsa"}>
                  <VariantProductsTableModal onClose={close} products={variantProducts} />
                </PurchaseTypeProvider>
              </PurchasePlaceProvider>
            ));
          }}
          type={"button"}
        >
          {t("page.sa.housing.seemore")}
        </LinkButton>
      </div>
    );
  }

  return <ProductTabularViewActionCell productCode={product.code} isHousing={true} />;
};
